import React from 'react';

import { FolderMinusIcon } from '@vlabs/icons';
import { Button } from '@vlabs/uikit/components/controls/button/Button';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button/Button';
import { useTranslation } from 'react-i18next';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import { confirmDetachCardFromList } from './confirm-detach-card-from-list';
import type { DetachCardsFromListProps } from './types';
import { useCardListLinker } from '@vlabs/api/useCardListLinker';

interface DetachCardsFromListButtonProps extends
  DetachCardsFromListProps,
  ButtonProps {}

const displayName = 'DetachCardsFromListButton';
const testid = buildTestid(displayName);

export function DetachCardsFromListButton({
  cardIds,
  fromListId,
  onDetachCardsFromList = undefined,
  'data-testid': dataTestId = undefined,
  ...props
}: DetachCardsFromListButtonProps): React.JSX.Element {
  const { t } = useTranslation();
  const detachCards = useCardListLinker(({
    action: 'detach', cardIds, listId: fromListId, onSuccess: onDetachCardsFromList,
  }));

  const onClickHandler = () => {
    confirmDetachCardFromList({
      listId: fromListId,
      onConfirm: detachCards,
    });
  };

  return (
    <Button
      icon={<FolderMinusIcon />}
      onClick={onClickHandler}
      variant="flat"
      {...testid(dataTestId, fromListId)}
      {...props}
    >
      {t('features:detachCardsFromList.detach')}
    </Button>
  );
}
